// import ApiSso from './sso';

class auth {
    
    /* Inserir validação via api para validar o token */
    hasToken() {
        if (localStorage.getItem('token') && localStorage.getItem('isLogged') && localStorage.getItem('user_email')) {
            return true;
        }
    
        return false;
    }
    
    login(){
        if (localStorage.getItem('user_email') && localStorage.getItem('is_register') === 'false'){
            return true;
        }

        return false;
    }

    register(){
        if (localStorage.getItem('user_email') && localStorage.getItem('is_register') === 'true'){
            return true;
        }

        return false;
    }

    payment(){
        if (localStorage.getItem('token') && localStorage.getItem('user_looged') === 'true' && localStorage.getItem('user_email')) {
            return true;
        }
    }

}
export default new auth();